/*
 * N49 Framework
 * 2020-2021
 */

(function ($) {
  let N49 = {
    debug: false,
    ajaxURL: "//" + location.host + "/wp-admin/admin-ajax.php",

    init: function (debug = false) {
      this.debug = debug;
      this.handle__accordion();
      this.handle__font_resize();
      this.handle__lightbox();
      this.handle__masonry();
      this.handle__mobile_nav();
      this.handle__scroll_to_top();
      this.handle__sliders();
      this.handle__videos();
      this.handle__quiz();
      this.handle__show_on_scroll();
      this.handle__archive();
      this.handle__socialButtons();
      this.page();
      this.handle__sticky_header();
    },

    page: function () {
      // YouTube
      var tag = document.createElement("script");

      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      $(".subscribe form").submit(function (e) {
        let errorMSG = "";
        let error = false;

        let email = $(this).find("input[type*=email]").val();
        let consent = $(this).find("input[type*=checkbox]:checked").length;

        const emailReg = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
        if (!emailReg.test(email)) {
          errorMSG +=
            "- Das E-Mail-Feld ist leer oder falsch geschrieben \n \n";
          error = true;
        }

        if (!consent) {
          errorMSG +=
            '- Bitte auf "Ich habe die Datenschutzerklärung gelesen und akzeptiert." Klicken';
          error = true;
        }

        if (error) {
          alert(errorMSG);
          e.preventDefault();
          return false;
        }
      });
    },
    handle__sticky_header: function () {
      // When the user scrolls the page, execute myFunction
      window.addEventListener("scroll", stickyHeader);

      // Get the header
      let header = document.getElementById("stickyHeader");
      let content = document.getElementById("mainContent");

      // Get the offset position of the navbar
      let sticky = header.offsetTop;

      // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
      function stickyHeader() {
        if (window.scrollY > sticky) {
          header.classList.add("sticky");
          content.classList.add("header-is-sticky");
        } else {
          header.classList.remove("sticky");
          content.classList.remove("header-is-sticky");
        }
      }
    },
    handle__accordion: function () {
      $(".js-accordion").on("click", ".accordion__head", function (evt) {
        $(this)
          .next()
          .stop()
          .slideToggle()
          .parent()
          .toggleClass("is-active")
          .siblings()
          .removeClass("is-active")
          .find(".accordion__body")
          .slideUp();

        evt.preventDefault();
      });
    },
    handle__font_resize: function () {
      const steps = ["low", "mid", "large"];

      $(".js-resize-btn").on("click", function (event) {
        const currentStep = $(this).data("current-step");
        const nextStepIndex = steps.indexOf(currentStep) + 1;
        const nextStep = steps[nextStepIndex] ? steps[nextStepIndex] : steps[0];
        const stepValue = parseInt($(this).data("step"), 10);

        $(".js-resize").each(function () {
          const $this = $(this);
          const currentFontSize = parseInt(
            $this.css("font-size").split("px")[0],
            10
          );

          $this.css("font-size", `${currentFontSize + stepValue}px`);

          if (nextStep === "low") {
            $this.css("font-size", `${currentFontSize - stepValue * 2}px`);
          }
        });

        $(this).data("current-step", nextStep);

        event.preventDefault();
      });
    },
    handle__lightbox: function () {
      /**
       * Init lightbox
       */

      $(".js-lightbox").swipebox();
    },
    handle__masonry: function () {
      /**
       * Masonry layout
       */

      $(window).on("load", () => {
        initMasonry();
      });

      const initMasonry = () => {
        if (!$(".js-masonry").length) {
          return;
        }

        const masonryGrid = new Masonry(".js-masonry", {
          columnWidth: ".gallery__item",
          percentPosition: true,
        });
      };
    },
    handle__mobile_nav: function () {
      /**
       * Mobile nav
       */

      $(".js-nav").on("click", function (evt) {
        $(this).toggleClass("is-active");

        $(".header__content").toggleClass("is-visible");

        evt.preventDefault();
      });
    },
    handle__scroll_to_top: function () {
      const scrollTo = document.querySelector(".js-scroll-to");

      if (scrollTo === null) {
        return;
      }

      const targetSection = document.querySelector(scrollTo.hash);
      const targetTop = targetSection.offsetTop;

      scrollTo.addEventListener("click", function (evt) {
        window.scrollTo({
          top: targetTop,
          behavior: "smooth",
        });

        evt.preventDefault();
      });
    },
    handle__sliders: function () {
      /**
       * Sliders.
       */

      const initSlider = () => {
        const $slider = $(".js-slider");

        if (!$slider.length) {
          return;
        }

        const basicTns = tns({
          container: ".js-slider .slider__slides",
          items: 1,
          slideBy: "page",
          loop: true,
          controls: false,
          autoplayButtonOutput: false,
          navPosition: "bottom",
          speed: 500,
          autoplay: true,
          gutter: 30,
        });
      };

      const initSliderGallery = () => {
        const $sliderGallery = $(".js-slider-gallery");

        if (!$sliderGallery.length) {
          return;
        }

        const $sliderDots = $sliderGallery.find(".js-slider-dots");

        const $galleryTns = tns({
          container: ".js-slider-gallery .slider__slides",
          items: 1,
          slideBy: "page",
          autoplay: true,
          loop: true,
          autoplayButtonOutput: false,
          nav: true,
          navContainer: ".js-slider-gallery .js-slider-nav ul",
          navAsThumbnails: true,
          speed: 500,
          startIndex: 0,
          mode: "gallery",
          controlsContainer: ".js-slider-gallery .js-slider-controls",
          onInit: function (info) {
            const activeIdx = info.index;

            $sliderDots.each((idx, nav) => {
              const sliderDotsLi = $(nav).find("li");

              sliderDotsLi.removeClass("is-current");
              sliderDotsLi.eq(activeIdx).addClass("is-current");
            });
          },
        });

        $sliderDots.on("click", "a", function (evt) {
          const $selectedNavItem = $(this).parent();
          const idx = $selectedNavItem.index();

          $galleryTns.goTo(idx);

          evt.preventDefault();
        });

        $galleryTns.events.on("transitionStart", function () {
          const activeIdx = $galleryTns.getInfo().index;

          $sliderDots.each((idx, nav) => {
            const sliderDotsLi = $(nav).find("li");

            sliderDotsLi.removeClass("is-current");
            sliderDotsLi.eq(activeIdx).addClass("is-current");
          });
        });
      };

      const initSliderMobile = () => {
        const $sliderMobile = $(".js-slider-mobile");

        if (!$sliderMobile.length) {
          return;
        }

        const sliderContainers = $(".js-slider-mobile .slider__slides");

        const $sliderNav = $($sliderMobile).find(".js-slider-nav");

        sliderContainers.each((idx, sliderContainer) => {
          const mobileTns = tns({
            container: sliderContainer,
            items: 1,
            slideBy: 1,
            loop: true,
            controls: false,
            autoplayButtonOutput: false,
            nav: true,
            navPosition: "bottom",
            speed: 500,
            autoplay: true,
            autoplayTimeout: 5000,
            gutter: 30,
            disable: false,
            responsive: {
              767: {
                items: 2,
                disable: true,
              },
            },
          });

          $sliderNav.find("a").on("click", function (evt) {
            const $selectedNavItem = $(this).parent();
            const idx = $selectedNavItem.index();

            mobileTns.goTo(idx);

            evt.preventDefault();
          });

          mobileTns.events.on("transitionStart", (data) => {
            const currentIndex = data.navCurrentIndex;

            $sliderNav
              .find("li")
              .eq(currentIndex)
              .addClass("is-current")
              .siblings()
              .removeClass("is-current");
          });
        });
      };

      initSlider();
      initSliderGallery();
      initSliderMobile();
    },
    handle__videos: function () {
      /**
       * Handle youtube video.
       */

      const youtubeVideos = [];

      /**
       * onYouTubeIframeAPIReady
       * @return {void}
       */
      window.onYouTubeIframeAPIReady = () => {
        $(".js-yt-video").each((idx, domNode) => {

          const $this = $(domNode);

          if (!$this.length) {
            return;
          }

          const id = $this.attr("id");
          const videoId = $this.attr("id");

          youtubeVideos.push(
            new YT.Player(id, {
              videoId,
              playerVars: {
                playsinline: 1,
              },
              events: {
                onReady: (evt) => {
                  const currentVideo = evt.target;
                  //console.log(currentVideo);

                  $(".js-play-" + videoId).on(
                    "click",
                    function (ev) {

                      $(this).closest(".video").addClass("is-playing");

                      currentVideo.playVideo();

                      ev.preventDefault();
                    }
                  );
                },
              },
            })
          );
        });
      };
    },
    handle__quiz: function () {
      const your_answer = $(".your-answer > input");
      const quiz_answer = $(".quiz-answer > input");
      const quiz_question = $(".quiz-question > input");

      const right_answer = $("#right-answer");

      quiz_question.val($(".quiz--js h2:first").html());

      $(".option").each(function () {
        const option = $(this).children("label").text();
        quiz_answer.val(right_answer.text());

        $(this).click(function () {
          your_answer.val(option);

          $(".quiz--js").slideUp(500).delay(500).fadeOut(500);
          $(".quiz .quiz-wpforms").slideDown(500).delay(500).fadeIn(500);
        });
      });
    },
    handle__show_on_scroll: function () {
      /**
       * Handle footer actions show/hide
       */
      window.onload = (event) => {
        const showOnScroll = $(".js-show-on-scroll");

        $(window).on("load scroll", () => {
          const scrollTop = $(window).scrollTop();

          showOnScroll.toggleClass("is-visible", scrollTop > 500);
        });
      };
    },
    handle__archive: function () {
      $(".js--archive-ajax").ajaxArchive({
        ajax_base_url: N49.ajaxURL,
      });

      $(document).ajaxComplete(function () {
        let searchParams = new URLSearchParams(window.location.search);

        if (searchParams.has("a_page")) {
          $.smoothScroll({
            scrollElement: null,
            scrollTarget: $(".js--archive-ajax"),
          });
          return false;
        }
      });
    },
    handle__socialButtons: function () {
      {
        $(".js--social-share").on("click", "button", function () {
          $(this).parent().toggleClass("is-active");
        });
      }
    },
  };

  let Elementor_N49 = {
    initHeroSlider: function () {
      const $heroSlider = $(".js-slider-hero");

      if (!$heroSlider.length) {
        return;
      }

      const sliders = $(".js-hero-content");
      const sliders_data = sliders.data("slides");

      const $sliderNav = $(".js-slider-hero-nav");
      const $sliderDots = $(".js-slider-hero-dots");

      const heroTns = tns({
        container: ".js-slider-hero .slider__slides",
        items: 1,
        slideBy: "page",
        autoplay: true,
        loop: true,
        controls: false,
        autoplayButtonOutput: false,
        navPosition: "bottom",
        speed: 500,
        autoHeight: true,
        autoplayHoverPause: true,
      });

      heroTns.events.on("transitionStart", (data) => {
        const currentIndex = data.navCurrentIndex;

        const slider_content = sliders_data[currentIndex];

        $heroSlider.find(".tns-slide-active");
        $sliderNav
          .find("li")
          .eq(currentIndex)
          .addClass("is-current")
          .siblings()
          .removeClass("is-current");

        $sliderDots
          .find("li")
          .eq(currentIndex)
          .addClass("is-current")
          .siblings()
          .removeClass("is-current");

        sliders.find("h1").html(slider_content.bg_title);
        sliders.find("h3").html(slider_content.slider_title);
        sliders.find("p").html(slider_content.slider_text);
        sliders.find("a.btn span").html(slider_content.button_text);
        sliders.find("a.btn").attr("href", slider_content.button_link);
        sliders
          .find("a.btn")
          .attr("class", "btn " + slider_content.slider_button);

        // console.log(slider_content);
      });

      heroTns.events.on("transitionStart", (data) => {
        const idx = data.navCurrentIndex;
        $sliderDots
          .find("li")
          .eq(idx)
          .addClass("is-current")
          .siblings()
          .removeClass("is-current");
        $sliderNav
          .find("li")
          .eq(idx)
          .addClass("is-current")
          .siblings()
          .removeClass("is-current");
      });

      $sliderNav.on("click", "a", function (evt) {
        console.log("click");
        const $selectedNavItem = $(this).parent();
        const idx = $selectedNavItem.index();
        heroTns.goTo(idx);
        evt.preventDefault();
      });

      $sliderDots.on("click", "a", function (evt) {
        const $selectedNavItem = $(this).parent();
        const idx = $selectedNavItem.index();
        heroTns.goTo(idx);
        evt.preventDefault();
      });
    },
  };

  N49.init();

  $(window).on("elementor/frontend/init", function () {
    //hook name is 'frontend/element_ready/{widget-name}.{skin} - i dont know how skins work yet, so for now presume it will
    //always be 'default', so for example 'frontend/element_ready/slick-slider.default'
    //$scope is a jquery wrapped parent element
    elementorFrontend.hooks.addAction(
      "frontend/element_ready/n49__hero.default",
      function ($scope, $) {
        Elementor_N49.initHeroSlider();
      }
    );
  });
})(jQuery);
